// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3doEC","resendInfoText":"OnGoingPaymentBox_resendInfoText__3bLM0"};